<div class="container">
    <div class="card" style="margin-bottom: 15px">
        <div class="card-header">
            <div class="row" style="margin-left: '15px';margin-right:'15px'">

                <div class="col-5"><strong>Tävlingsnamn</strong>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="card" *ngFor="let competition of competitions">
                <div class="card-header">
                    <div class="row">
                        <div class="col-4">{{competition.comp.CompetitionName}} </div>
                        <div class="col-3" *ngIf="user?.globaladmin === 1 || dateIsPassed(competition.comp.VisibleToVoterFrom)">
                            <Button
                            (click)="onPdfClick(competition.comp, competition.ppi, competition.unSharp)" class="btn btn-primary position-relative"
                        >
                            <fa-icon [icon]="['fas', 'file-pdf']"></fa-icon>
                        </Button>
                        &nbsp;
                        <Button
                        (click)="onExportClick(competition.comp)" class="btn btn-primary position-relative"
                    >
                        <fa-icon [icon]="['fas', 'file-export']"></fa-icon>
                    </Button>
                    &nbsp;
                        <Button
                        (click)="onImagesExportClick(competition.comp)" class="btn btn-primary position-relative"
                    >
                        <fa-icon [icon]="['fas', 'file-archive']"></fa-icon>
                    </Button>
                    &nbsp;
            <button (click)="getAI(competition.comp)"  class="btn btn-primary position-relative"><fa-icon [icon]="['fas', 'robot']"></fa-icon></button>
                    <!--Button
                                                (click)="onWordClick(competition.comp)" class="btn btn-primary position-relative"
                                            >
                                                <fa-icon [icon]="['fas', 'file-word']"></fa-icon>
                                            </Button-->
                        </div>
                                        <div class="col-2" *ngIf="user?.globaladmin === 1 || dateIsPassed(competition.comp.VisibleToVoterFrom)">
                                            <label for="pixels">Pixlar per tum</label><br>
                                            <input id="pixels" [(ngModel)]="competition.ppi" type="number" style="width:95%">
                                        </div>
                                        <div class="col-2" *ngIf="user?.globaladmin === 1 || dateIsPassed(competition.comp.VisibleToVoterFrom)">
                                            <label for="unsharp">Oskarp mask</label><br>
                                            <input id="unsharp" [(ngModel)]="competition.unSharp" type="checkbox">
                                        </div>
                    </div>
                </div>
                <div class="card-body">
                   <app-sub-competition [subCompetitions]=competition.themes [competition]="competition" [user]=user></app-sub-competition>
                </div>
            </div>
        </div>
    </div>
</div>
